/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConfigResponseDto } from '../models';
// @ts-ignore
import type { UpdateConfigDto } from '../models';
/**
 * ConfigApi - axios parameter creator
 * @export
 */
export const ConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get business configuration for any channel
         * @param {string} businessId 
         * @param {GetConfigChannelEnum} channel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig: async (businessId: string, channel: GetConfigChannelEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('getConfig', 'businessId', businessId)
            // verify required parameter 'channel' is not null or undefined
            assertParamExists('getConfig', 'channel', channel)
            const localVarPath = `/api/v1/businesses/{businessId}/config`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update business configuration for any channel
         * @param {string} businessId 
         * @param {UpdateConfigChannelEnum} channel 
         * @param {UpdateConfigDto} updateConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfig: async (businessId: string, channel: UpdateConfigChannelEnum, updateConfigDto: UpdateConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('updateConfig', 'businessId', businessId)
            // verify required parameter 'channel' is not null or undefined
            assertParamExists('updateConfig', 'channel', channel)
            // verify required parameter 'updateConfigDto' is not null or undefined
            assertParamExists('updateConfig', 'updateConfigDto', updateConfigDto)
            const localVarPath = `/api/v1/businesses/{businessId}/config`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigApi - functional programming interface
 * @export
 */
export const ConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get business configuration for any channel
         * @param {string} businessId 
         * @param {GetConfigChannelEnum} channel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfig(businessId: string, channel: GetConfigChannelEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfig(businessId, channel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigApi.getConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update business configuration for any channel
         * @param {string} businessId 
         * @param {UpdateConfigChannelEnum} channel 
         * @param {UpdateConfigDto} updateConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConfig(businessId: string, channel: UpdateConfigChannelEnum, updateConfigDto: UpdateConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConfig(businessId, channel, updateConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigApi.updateConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConfigApi - factory interface
 * @export
 */
export const ConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigApiFp(configuration)
    return {
        /**
         * 
         * @summary Get business configuration for any channel
         * @param {string} businessId 
         * @param {GetConfigChannelEnum} channel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfig(businessId: string, channel: GetConfigChannelEnum, options?: RawAxiosRequestConfig): AxiosPromise<ConfigResponseDto> {
            return localVarFp.getConfig(businessId, channel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update business configuration for any channel
         * @param {string} businessId 
         * @param {UpdateConfigChannelEnum} channel 
         * @param {UpdateConfigDto} updateConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfig(businessId: string, channel: UpdateConfigChannelEnum, updateConfigDto: UpdateConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<ConfigResponseDto> {
            return localVarFp.updateConfig(businessId, channel, updateConfigDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigApi - object-oriented interface
 * @export
 * @class ConfigApi
 * @extends {BaseAPI}
 */
export class ConfigApi extends BaseAPI {
    /**
     * 
     * @summary Get business configuration for any channel
     * @param {string} businessId 
     * @param {GetConfigChannelEnum} channel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public getConfig(businessId: string, channel: GetConfigChannelEnum, options?: RawAxiosRequestConfig) {
        return ConfigApiFp(this.configuration).getConfig(businessId, channel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update business configuration for any channel
     * @param {string} businessId 
     * @param {UpdateConfigChannelEnum} channel 
     * @param {UpdateConfigDto} updateConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    public updateConfig(businessId: string, channel: UpdateConfigChannelEnum, updateConfigDto: UpdateConfigDto, options?: RawAxiosRequestConfig) {
        return ConfigApiFp(this.configuration).updateConfig(businessId, channel, updateConfigDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetConfigChannelEnum = {
    Wolt: 'Wolt',
    MunchiOnline: 'MunchiOnline',
    MunchiKiosk: 'MunchiKiosk',
    MunchiPos: 'MunchiPos',
    UberEats: 'UberEats',
    Foodora: 'Foodora',
    Bolt: 'Bolt',
    MunchiKioskV2: 'MunchiKioskV2',
    Kiosk: 'Kiosk',
    WoltStorefront: 'WoltStorefront',
    Storefront: 'Storefront',
    MunchiPay: 'MunchiPay'
} as const;
export type GetConfigChannelEnum = typeof GetConfigChannelEnum[keyof typeof GetConfigChannelEnum];
/**
 * @export
 */
export const UpdateConfigChannelEnum = {
    Wolt: 'Wolt',
    MunchiOnline: 'MunchiOnline',
    MunchiKiosk: 'MunchiKiosk',
    MunchiPos: 'MunchiPos',
    UberEats: 'UberEats',
    Foodora: 'Foodora',
    Bolt: 'Bolt',
    MunchiKioskV2: 'MunchiKioskV2',
    Kiosk: 'Kiosk',
    WoltStorefront: 'WoltStorefront',
    Storefront: 'Storefront',
    MunchiPay: 'MunchiPay'
} as const;
export type UpdateConfigChannelEnum = typeof UpdateConfigChannelEnum[keyof typeof UpdateConfigChannelEnum];
